import React from 'react';
import { Block } from '@mui/icons-material';
import arm1 from "../img/arm/arm1.png";
import arm2 from "../img/arm/arm2.png";
import arm3 from "../img/arm/arm3.png";

const Arms = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Common arm positioning mistakes to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={arm1} alt="Incorrect arm positioning example 1" onClick={() => onImageClick && onImageClick(arm1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
               The arm is missing
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={arm2} alt="Incorrect arm positioning example 2" onClick={() => onImageClick && onImageClick(arm2)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
              The arm is missing
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={arm3} alt="Incorrect arm positioning example 3" onClick={() => onImageClick && onImageClick(arm3)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                She does not have left arm
              </div>
            </div>
          </div>
          
        
        </div>
      </div>
    </>
  );
};

export default Arms;